import React, { createRef, ProviderProps, useContext, useEffect, useState } from "react";

import { ReactComponent as IconoOpcionUsuario } from "assets/icons/Sidebar_Nuevo_Opciones/usuario.svg"
import { ReactComponent as DirectivoUNIDAD } from "assets/icons/Sidebar_Nuevo_Opciones/DirectivoUNIDAD.svg"
import { ReactComponent as Administrador } from "assets/icons/Sidebar_Nuevo_Opciones/Admin.svg"
import { ReactComponent as IconoOpcionConsultor } from "assets/icons/Sidebar_Nuevo_Opciones/Consultor.svg"

import { expresion_civil } from 'components/Admin/Inicio-Admin/Dashboard_Admin';

import dashRoutes from "routes";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { authenticationService } from "services/authentication.service";

export const ROL_ADMINISTRADOR = "ADMINISTRADOR"
export const ROL_USUARIO = "USUARIO"
export const ROL_MUJER = "MUJER"
export const ROL_DIRECTIVO_UNIDAD = "DIRECTIVO_UNIDAD"
export const ROL_APROBADOR = "APROBADOR"
export const ROL_COMI_ESCALAFON = "COMISION ESCALAFON"
export const ROL_CONSULTOR = "CONSULTOR"
export const ROL_DELEGADO = "DELEGADO"
export const ROL_ENCARGADO_GPE = "ENCARGADO GPE"
export const ROL_ANALISTA_GPE = "ANALISTA GPE";
export const ROL_DIRECTOR_TALENTOHUMANO = "DIRECTOR TH"
export const ROL_DELEGADO_DIRECTOR_TALENTOHUMANO = "DELEGADO DIRECTOR TH"
export const ROL_SUBROGANTE_TH = "SUBROGANTE TH"
export const ROL_ANALISTA_TH = "ANALISTA TH"
export const ROL_ANALISTA_TH_AP = "ANALISTA TH AP"
export const ROL_NOMINA_TH_HE = "NOMINA TH HE"
export const ROL_RECTOR = "RECTOR"
export const ROL_VICERRECTOR = "VICERRECTOR"
export const ROL_DELEGADO_RECTOR = "DELEGADO RECTOR"
export const ROL_DELEGADO_VICERRECTOR = "DELEGADO VICERRECTOR"
export const ROL_ASESOR = "ASESOR"
export const ROL_DOCTOR_PERMISO = "DOCTOR PERMISO"
export const ROL_NOMINA_TH = "NOMINA TH"
export const ROL_USUARIO_SUBROGANTE = "USUARIO SUBROGANTE";
export const ROL_FIRMA_HORAS_EXTRAS = "ENCARGADO FIRMA HE";
export const ROL_GERENTE_FINANCIERO = "GERENTE FINANCIERO";
export const ROL_RESPONSABLE_TH_CONSULTOR = "RESPONSABLE TH CONSULTOR";

//TITULOS PARA SIDEBAR
export const OPCION_TITULO_PLANIFICACION_VACACIONES = "Planificación Vacaciones"
export const OPCION_TITULO_ACTUALIZACION_DATOS = "Actualización de Datos"
export const OPCION_TITULO_ASIGNACION_PRESUPUESTO = "Asignación Presupuesto"
export const OPCION_TITULO_MODIFICACION_PRESUPUESTO = "Modificación Presupuesto"
export const OPCION_TITULO_HISTORIAL_MOD_PRESUPUESTO = "Historial Modificaciones Presupuesto"
export const OPCION_TITULO_MODIFICACION_PRESUPUESTO_UNIDAD = "Solicitar Modificacion Presupuesto"
export const OPCION_TITULO_FIRMA_DOC_PAGO_HE = "Firma Documento Pago"

//MARCACIONES SERVIDOR Y DIRECTIVO
export const OPCION_TITULO_HISTORICO_MARCACIONES = "Historial de marcaciones / justificaciones";
export const OPCION_TITULO_CONSULTA_HOJA_MARCACIONES = "Consultar hoja de marcaciones"

export const ROUTE_HISTORIAL_MARCACIONES = "/web/historial_marcaciones";
export const ROUTE_HOJA_MARCACIONES = "/web/hojamarcacion";
//OPCIONES NOMBRES
export const TITULO_EMISION_CERTIFICADOS = "Emisión Certificados"

export type Rutas_Datos_Personales = {
    path: string,
    name: string,
    icon: any,
    component: any,
    layout: string,
    color: string,
    rol?: Array<string>
    condicionMostrar?: (datos?: any) => boolean
}
export type TipoSideBar = {
    rows: Boolean,
    dropdown: Boolean
}

export interface opcionesSideBar {
    titulo: string,
    tituloStyled?: any,
    entries?: Array<opcionesSideBar>,
    tipo: TipoSideBar,
    rol_usuario?: string,
    icon?: any,
    link?: string,
    condicionMostrar?: (datos?: any) => boolean
}
const SideBarContext = React.createContext({
    subMenuCuartoNivel: false,
    setsubMenuCuartoNivel: (estado: boolean) => { },
    valoressubMenuCuartoNivel: new Array<opcionesSideBar>(),
    setvaloressubMenuCuartoNivel: (estado: any) => { },
    titulo_opcion_CuartoNivel: "",
    settitulo_opcion_CuartoNivel: (estado: string) => { },

    subMenuNieto: false,
    setsubMenuNieto: (estado: boolean) => { },
    valoressubMenuNieto: new Array<opcionesSideBar>(),
    setvaloressubMenuNieto: (estado: any) => { },

    titulo_opcion_submenuNieto: "",
    settitulo_opcion_submenuNieto: (estado: string) => { },
    subMenu: false,
    setsubMenu: (estado: boolean) => { },
    valoressubMenu: new Array<opcionesSideBar>(),
    setvaloressubMenu: (estado: any) => { },
    valoresMenuPrincipal: new Array<opcionesSideBar>(),
    setvaloresMenuPrincipal: (estado: Array<opcionesSideBar>) => { },
    titulo_opcion_padre: "",
    settitulo_opcion_padre: (estado: string) => { },
    icono_opcion_padre: <IconoOpcionUsuario />,
    seticono_opcion_padre: (icono: any) => { },
    subMenuDatosPersonales: false,
    setsubMenuDatosPersonales: (estado: boolean) => { },
    NOMBRE_OPCION_DATOS_PERSONALES: "",
    routes_datos_personales: new Array<Rutas_Datos_Personales>(),
    routes_usuarios_generales: new Array<opcionesSideBar>(),
    showSideBar: true,
    setshowSideBar: (estado: boolean) => { }
});

export function useSideBarContext() {
    const contexto = React.useContext(SideBarContext);
    if (!contexto) {
        throw new Error('Para usar el hook asegurese de ser hijo del Proveedor SideBarContextProvider');
    }
    return contexto;
}

export const RUTAS_DESVINCULACION_USUARIO: { nombreRuta: string, ruta: string, layout: string, estados?: string[] }[] = [
    {
        nombreRuta: "Solicitud de Desvinculación",
        layout: "/admin",
        ruta: "/desvinculacion",
    },
    {
        nombreRuta: "Deudas pendientes",
        layout: "/admin",
        ruta: "/deudas-pendientes",
        estados: ["RDC", "REV", "CLQ", "FLQ", "TVL"]
    },
    {
        ruta: "/documentos-a-entregar",
        nombreRuta: "Documentos a entregar",
        layout: "/admin",
        estados: ["RDC", "REV", "CLQ", "FLQ", "TVL"]
    },
    {
        ruta: "/documentos-a-firmar-servidor",
        nombreRuta: "Documentos a firmar servidor",
        layout: "/admin",
        estados: ["RDC", "REV", "CLQ", "FLQ", "TVL"]
    },
    {
        ruta: "/estado-de-desvinculacion",
        nombreRuta: "Estado de desvinculacion",
        layout: "/admin",
        estados: ["PRE", "APR", "RDC", "REV", "CLQ", "FLQ", "TVL", "LIQ"]
    }
]

export const RUTAS_VINCULACION_USUARIO: { nombreRuta: string, ruta: string, layout: string, estados?: string[] }[] = [
    {
        nombreRuta: "Documentos a Entregar",
        layout: "/admin",
        ruta: "/documentos-a-entregar",
    }
]

export function mapeoRolesDesvinculacionDirectivo(rolesdesvinculacion: string[]) {
    var rolesDatosPersonales: string[] = [];
    var v = ""
    rolesdesvinculacion.map((val, ind) => {
        switch (val) {
            case "RECTORADO":
                rolesDatosPersonales.push(ROL_RECTOR);
                break;
            case "VICERRECTORADO":
                rolesDatosPersonales.push(ROL_VICERRECTOR);
                break;
            case "DIRECTIVO":
                rolesDatosPersonales.push(ROL_DIRECTIVO_UNIDAD);
                break;
            case "DELEGADO":
                rolesDatosPersonales.push(ROL_DELEGADO);
                break;
            case "DIRECTORTH":
                rolesDatosPersonales.push(ROL_DIRECTOR_TALENTOHUMANO);
                break;
            case "DELEGADO_RECTORADO":
                rolesDatosPersonales.push(ROL_DELEGADO_RECTOR);
                break;
            case "DELEGADO_VICERRECTORADO":
                rolesDatosPersonales.push(ROL_DELEGADO_VICERRECTOR);
                break;
            default:
                break;
        }
    })
    return rolesDatosPersonales
}

export const RUTAS_DESVINCULACION_DIRECTIVO: { nombreRuta: string, ruta: string, layout: string, roles?: string[] }[] = [
    {
        ruta: "/reporte-de-deudas",
        nombreRuta: "Certificación de deudas",
        layout: "/admin",
        roles: ["RECTORADO", "VICERRECTORADO", "DIRECTIVO", "DIRECTIVONOESPOL"],
    },
    {
        ruta: "/solicitudes-de-renuncia",
        nombreRuta: "Aprobación de Solicitudes",
        layout: "/admin",
        roles: ["RECTORADO", "VICERRECTORADO"]
    },

    {
        ruta: "/documentos-a-firmar",
        nombreRuta: "Documentos a firmar",
        layout: "/admin",
        roles: ["RECTORADO", "VICERRECTORADO"],
    },
    {
        ruta: "/terminacion-contrato",
        nombreRuta: "Solicitud para Terminación de Contrato por Cumplimiento de Plazo",
        layout: "/admin",
        roles: ["DIRECTIVO", "RECTORADO", "VICERRECTORADO"],
    },
    {
        ruta: "/terminacion-unilateral",
        nombreRuta: "Solicitud para Terminación Unilateral de Contrato",

        layout: "/admin",

        roles: ["DIRECTIVO", "RECTORADO", "VICERRECTORADO"],
    },
    {
        ruta: "/notificardesvinculacionunilateral",
        nombreRuta: "Notificación Desvinculación Unilateral",

        layout: "/admin",

        roles: ["DIRECTORTH"],
    },
    {
        ruta: "/reportecertificadodeuda",
        nombreRuta: "Historial de Certificaciones de deudas",

        layout: "/admin",

        roles: ["DIRECTIVO", "DELEGADO", "RECTORADO", "VICERRECTORADO"],
    },
    {
        ruta: "/historialsolicitudes",
        nombreRuta: "Historial de Desvinculaciones de la Unidad",

        layout: "/admin",

        roles: ["DIRECTIVO", "DELEGADO", "RECTORADO", "VICERRECTORADO"],
    },
    {
        ruta: "/historialsolicitudesautorizadas",
        nombreRuta: "Historial Desvinculaciones autorizadas",

        layout: "/admin",

        roles: ["DELEGADO_RECTORADO", "DELEGADO_VICERRECTORADO", "RECTORADO", "VICERRECTORADO"],
    }
]

export function EstadosDesvinculacionValidation(nombreOpcion: string, estadosUsuario: string[]) {
    var matchruta = RUTAS_DESVINCULACION_USUARIO.filter(ruta => ruta.nombreRuta === nombreOpcion)
    if (matchruta.length > 0 && matchruta[0].estados === undefined) {
        return true;
    }
    else if (estadosUsuario && matchruta.length > 0 && matchruta[0].estados) {
        var matchestados = matchruta[0].estados.filter(estado => estadosUsuario.includes(estado));
        return matchestados.length > 0;
    }
    return false;
}

export function IsOpcionDesvinculacionUsuario(nombreOpcion: string) {
    var matchruta = RUTAS_DESVINCULACION_USUARIO.filter(ruta => ruta.nombreRuta === nombreOpcion)
    return matchruta.length > 0;
}

export function IsOpcionDesvinculacionDirectivo(nombreOpcion: string) {
    var matchruta = RUTAS_DESVINCULACION_DIRECTIVO.filter(ruta => ruta.nombreRuta === nombreOpcion)
    return matchruta.length > 0;
}

const SideBarContextProvider: React.FC = ({ children }) => {
    const [showSideBar, setshowSideBar] = useState<boolean>(false)
    const [subMenu, setsubMenu] = useState<boolean>(false);
    const [subMenuNieto, setsubMenuNieto] = useState<boolean>(false);
    const [subMenuCuartoNivel, setsubMenuCuartoNivel] = useState<boolean>(false);

    const [subMenuDatosPersonales, setsubMenuDatosPersonales] = useState<boolean>(false);
    const [valoressubMenu, setvaloressubMenu] = useState<Array<opcionesSideBar>>([]);
    const [valoressubMenuNieto, setvaloressubMenuNieto] = useState<Array<opcionesSideBar>>([]);
    const [valoressubMenuCuartoNivel, setvaloressubMenuCuartoNivel] = useState<Array<opcionesSideBar>>([]);

    const [valoresMenuPrincipal, setvaloresMenuPrincipal] = useState<Array<opcionesSideBar>>([]);
    const [titulo_opcion_padre, settitulo_opcion_padre] = useState<string>("")
    const [titulo_opcion_submenuNieto, settitulo_opcion_submenuNieto] = useState<string>("")
    const [titulo_opcion_CuartoNivel, settitulo_opcion_CuartoNivel] = useState<string>("")

    const [icono_opcion_padre, seticono_opcion_padre] = useState<any>(<IconoOpcionUsuario />)

    const URL_LOCAL_DESVINCULACION = "http://localhost:63258"
    const URL_PRUEBA_DESVINCULACION = "http://192.168.253.7:8090"
    const URL_SITIO_DESVINCULACION = "https://desvinculacion.espol.edu.ec"

    const URL_DESVINCULACION = URL_SITIO_DESVINCULACION;
    //const [datos, setdatos] = useState<UserData>()

    //useEffect(() => {
    //     var datos:UserData = authenticationService.currentUserValue;
    //     if(datos){
    //         setdatos(datos)
    //     }
    //}, [])
    let routes_datos_personales: Array<Rutas_Datos_Personales> = dashRoutes;
    const NOMBRE_OPCION_DATOS_PERSONALES = "Información Personal";
    // const value = useMemo(() =>  , [])

    let OpcionesAdministrador: Array<opcionesSideBar> = [
        {
            titulo: "RESPONSABLE TH",
            icon: () => { return <Administrador id="icono_opcion_administrador" className="iconoBarraPrincipal" /> },
            entries: [
                {
                    titulo: "Solicitudes Administrativas", entries: [
                        {
                            titulo: "Certificados",
                            tipo: { rows: true, dropdown: true },
                            entries: [
                                { titulo: "Firmar Certificados", tipo: { rows: false, dropdown: false }, link: "/admin/firmarCertificados", rol_usuario: ROL_DIRECTOR_TALENTOHUMANO },
                                { titulo: "Emisión Certificados", tipo: { rows: false, dropdown: false }, link: "/admin/emisionCertificados", },
                                { titulo: "Historial Emisión Certificados", tipo: { rows: false, dropdown: false }, link: "/admin/historialEmisionCertificados", },
                            ],
                            rol_usuario: ROL_ADMINISTRADOR
                        },
                        {
                            titulo: "Permisos / Licencias",
                            tipo: { rows: true, dropdown: false },
                            entries: [
                                { titulo: "Elaboración de AP / Validación de Permisos", tipo: { rows: false, dropdown: false }, link: "/admin/aprobacionSolicitudesTh", rol_usuario: ROL_ANALISTA_TH_AP },
                                { titulo: "Revisión de AP", tipo: { rows: false, dropdown: false }, link: "/admin/RevisionSolicitudes", rol_usuario: ROL_ANALISTA_TH_AP },
                                { titulo: "Registro y Control de AP", tipo: { rows: false, dropdown: false }, link: "/admin/RegistroSolicitudes", rol_usuario: ROL_ANALISTA_TH_AP },
                                { titulo: "Notificación Embarazo", tipo: { rows: false, dropdown: false }, link: "/admin/validacionNotificacionEmbarazo" },
                                { titulo: "Firmar Acción de Personal", tipo: { rows: false, dropdown: false }, link: "/admin/firmaAPNomina", rol_usuario: ROL_NOMINA_TH },
                                { titulo: "Firmar Acción de Personal", tipo: { rows: false, dropdown: false }, link: "/directivo/firmaAPNomina", rol_usuario: ROL_DIRECTOR_TALENTOHUMANO },
                                { titulo: "Notificar Accion de Personal", tipo: { rows: false, dropdown: false }, link: "/directivo/notificarSolicitudes", rol_usuario: ROL_DIRECTOR_TALENTOHUMANO },
                                { titulo: "Solicitudes pendientes de regularización", tipo: { rows: false, dropdown: false }, link: "/admin/historialSolicitudesNotificadoTH", },
                                { titulo: "Historial de permisos y licencias", tipo: { rows: false, dropdown: false }, link: "/admin/historialSolicitudesTH", },
                            ],
                            rol_usuario: ROL_ADMINISTRADOR
                        },
                        //{
                        //    titulo: "Vacaciones",
                        //    tipo: { rows: true, dropdown: true },
                        //    entries: [
                        //        { titulo: "Reporte plan de vacaciones U.", tipo: { rows: false, dropdown: false }, link: "/admin/cronogramaVacaciones" },
                        //        { titulo: "Elaboración de AP de Vacaciones / Validación de Permisos", tipo: { rows: false, dropdown: false }, link: "/admin/aprobacionVacacionesTh", rol_usuario: ROL_ANALISTA_TH_AP },
                        //        { titulo: "Revisión de AP de Vacaciones", tipo: { rows: false, dropdown: false }, link: "/admin/revisionVacacionesTh", rol_usuario: ROL_ANALISTA_TH_AP },
                        //        { titulo: "Firmar AP de Vacaciones", tipo: { rows: false, dropdown: false }, link: "/admin/firmaAPVacaciones", rol_usuario: ROL_NOMINA_TH },
                        //        { titulo: "Firmar AP de Vacaciones", tipo: { rows: false, dropdown: false }, link: "/directivo/firmaAPVacaciones", rol_usuario: ROL_DIRECTOR_TALENTOHUMANO },
                        //        { titulo: "Registro y Control de AP de Vacaciones", tipo: { rows: false, dropdown: false }, link: "/admin/registroVacacionesTh", rol_usuario: ROL_ANALISTA_TH_AP },
                        //        { titulo: "Notificar AP de Vacaciones", tipo: { rows: false, dropdown: false }, link: "/directivo/notificarVacacionesTh", rol_usuario: ROL_DIRECTOR_TALENTOHUMANO },
                        //        { titulo: "Historial de AP de Vacaciones", tipo: { rows: false, dropdown: false }, link: "/admin/historialVacacionesTh", },
                        //    ],
                        //    rol_usuario: ROL_ADMINISTRADOR
                        //},
                        {
                            titulo: "Horas Extras",
                            tipo: { rows: true, dropdown: true },
                            entries: [
                                { titulo: "Parámetros ", tipo: { rows: false, dropdown: false }, link: "/admin/horasExtras/parametros", rol_usuario: ROL_ANALISTA_TH },
                                { titulo: "Proyección ", tipo: { rows: false, dropdown: false }, link: "/admin/horasExtras/proyeccion", rol_usuario: ROL_ANALISTA_TH },
                                { titulo: "Planificación ", tipo: { rows: false, dropdown: false }, link: "/admin/horasExtras/planificacion", rol_usuario: ROL_ANALISTA_TH },
                                { titulo: "Ingreso Manual Solic. Pago ", tipo: { rows: false, dropdown: false }, link: "/admin/horasExtras/solicitudpago", rol_usuario: ROL_ANALISTA_TH },
                                { titulo: "Revisión Solicitudes ", tipo: { rows: false, dropdown: false }, link: "/admin/horasExtras/Revisar", rol_usuario: ROL_ANALISTA_TH },
                                { titulo: "Ejecución Presupuestaria Horas Extras", tipo: { rows: false, dropdown: false }, link: "/admin/horasExtras/historicounidades", rol_usuario: ROL_ANALISTA_TH },
                                { titulo: "Historial Solicitudes ", tipo: { rows: false, dropdown: false }, link: "/admin/horasExtras/historialSolicitudes", rol_usuario: ROL_ANALISTA_TH },
                                { titulo: OPCION_TITULO_FIRMA_DOC_PAGO_HE, tipo: { rows: false, dropdown: false }, link: "/admin/horasExtras/firmadocumentopago", rol_usuario: ROL_FIRMA_HORAS_EXTRAS },
                                { titulo: "Asignar CUR ", tipo: { rows: false, dropdown: false }, link: "/admin/horasExtras/Asignar", rol_usuario: ROL_ANALISTA_TH },

                            ],
                            rol_usuario: ROL_ADMINISTRADOR
                        },
                        {
                            titulo: "Marcaciones",
                            tipo: { rows: true, dropdown: true },
                            entries: [
                                { titulo: "Consulta de Hoja de Marcaciones por persona", tipo: { rows: false, dropdown: false }, link: "/admin/hojaMarcacionesServidor" },
                                { titulo: "Consulta de Hoja de Marcaciones por unidad", tipo: { rows: false, dropdown: false }, link: "/admin/hojaMarcacionesUnidad" },
                                { titulo: "Planificación ", tipo: { rows: false, dropdown: false }, link: "/admin/horasExtras/planificacion", rol_usuario: ROL_ANALISTA_TH },

                            ],
                            rol_usuario: ROL_ADMINISTRADOR
                        }
                    ], tipo: { rows: true, dropdown: false }
                }
                // {
                //     titulo:"Autoridades ESPOL",
                //     tipo:{rows:false,dropdown:false}
                // },
                // {
                //     titulo:"Ingreso Coordinadores",
                //     tipo:{rows:false,dropdown:false}
                // },
                // {
                //     titulo:"Registro persona delegada",
                //     tipo:{rows:false,dropdown:false}
                // },
                // {
                //     titulo:"Certificados",
                //     entries:[
                //         {titulo:"Certificados",tipo:{rows:false,dropdown:false}},
                //         {titulo:"Firmar Certificados",tipo:{rows:false,dropdown:false}},
                //     ],
                //     tipo:{rows:true,dropdown:false}
                // },
                // {
                //     titulo:"Ingreso de Subrogación Administrativos",
                //     tipo:{rows:false,dropdown:false}
                // },
                // {
                //     titulo:"Mapa de Ubicación de Domicilios del Personal",
                //     tipo:{rows:false,dropdown:false}
                // },
                // {
                //     titulo:"Consulta Docentes Planificados",
                //     tipo:{rows:false,dropdown:false}
                // },
                // {
                //     titulo:"Contratación Administrativos",
                //     entries:[
                //         {titulo:"Revisión Formularios",tipo:{rows:false,dropdown:false}},
                //         {titulo:"Informe Final",tipo:{rows:false,dropdown:false}},
                //         {titulo:"Firma Contrato",tipo:{rows:false,dropdown:false}},

                //     ],
                //     tipo:{rows:true,dropdown:false}
                // },
                // {
                //     titulo:"Persona - Teletrabajo",
                //     tipo:{rows:false,dropdown:false}
                // },
                // {
                //     titulo:"Contratación Administrativos",
                //     entries:[
                //         {titulo:"Opcion 1",tipo:{rows:false,dropdown:false}},
                //         {titulo:"Opcion 2",tipo:{rows:false,dropdown:false}},
                //     ],
                //     tipo:{rows:true,dropdown:false}
                // }
            ],
            tipo: { rows: true, dropdown: false },
            rol_usuario: ROL_ADMINISTRADOR
        }
    ]

    let OpcionesResponsableTH_consultor: Array<opcionesSideBar> = [
        {
            titulo: "RESPONSABLE TH CONSULTOR",
            icon: () => { return <Administrador id="icono_opcion_administrador" className="iconoBarraPrincipal" /> },
            entries: [
                {
                    titulo: "Solicitudes Administrativas", entries: [
                        {
                            titulo: "Permisos / Licencias",
                            tipo: { rows: true, dropdown: false },
                            entries: [
                                { titulo: "Historial de permisos y licencias", tipo: { rows: false, dropdown: false }, link: "/admin/historialSolicitudesTH", },
                            ],
                            rol_usuario: ROL_ADMINISTRADOR
                        },
                        {
                            titulo: "Vacaciones",
                            tipo: { rows: true, dropdown: true },
                            entries: [
                                { titulo: "Historial de AP de Vacaciones", tipo: { rows: false, dropdown: false }, link: "/admin/historialVacacionesTh", },
                            ],
                            rol_usuario: ROL_ADMINISTRADOR
                        },
                        {
                            titulo: "Marcaciones",
                            tipo: { rows: true, dropdown: true },
                            entries: [
                                { titulo: "Consulta de Hoja de Marcaciones por persona", tipo: { rows: false, dropdown: false }, link: "/admin/hojaMarcacionesServidor" },
                                { titulo: "Consulta de Hoja de Marcaciones por unidad", tipo: { rows: false, dropdown: false }, link: "/admin/hojaMarcacionesUnidad" },
                            ],
                            rol_usuario: ROL_RESPONSABLE_TH_CONSULTOR
                        }
                    ], tipo: { rows: true, dropdown: false }
                }
            ],
            tipo: { rows: true, dropdown: false },
            rol_usuario: ROL_RESPONSABLE_TH_CONSULTOR
        }
    ]

    //let OpcionesNominaTH: Array<opcionesSideBar> = [
    //    {
    //        titulo: "ADMINISTRADOR",
    //        icon: () => { return <Administrador id="icono_opcion_administrador" className="iconoBarraPrincipal" /> },
    //        entries: [

    //            {
    //                titulo: "Aprobaciones",
    //                tipo: { rows: true, dropdown: true },
    //                entries: [

    //                    { titulo: "Firmar Acción de Personal", tipo: { rows: false, dropdown: false }, link: "/admin/firmaAPNomina", },

    //                ],
    //                rol_usuario: ROL_NOMINA_TH
    //            }
    //        ],
    //        tipo: { rows: true, dropdown: false },
    //        rol_usuario: ROL_NOMINA_TH
    //    }
    //]

    const STYLED_OPCION_APROBACION_SOLICIUDES = (
        <div className="texto_submenuOpcionesHeaderNieto">
            <div>{"Aprobación de Solicitudes"}</div>
        </div>
    )




    let OpcionesDirectivoUnidad: Array<opcionesSideBar> = [
        {
            titulo: "DIRECTIVO DE UNIDAD",
            icon: () => { return <DirectivoUNIDAD id="icono_opcion_directivo" className="iconoBarraPrincipal" /> },
            entries: [
                /*{
                    titulo: "Información del Personal a su cargo",
                    entries: [
                        {
                            titulo: "Marcaciones",
                            entries: [
                                //{ titulo: "Aprobación Solicitud Marcación", tipo: { rows: false, dropdown: false }, link: "/directivo/aprobacionSolicitudesMarcacion" },
                                { titulo: "Aprobación Solicitud Marcación", tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/directivo/aprobaciondirectivos" },
                                { titulo: "Consulta de marcaciones de personal", tipo: { rows: false, dropdown: false }, link: "/directivo/marcacionesPersonal", rol_usuario: ROL_DIRECTIVO_UNIDAD },
                            ],
                            tipo: { rows: true, dropdown: false }
                        },

                    ],
                    tipo: { rows: true, dropdown: false }
                },*/
                /*{
                    titulo: "Asistencia ", entries: [
                        //{ titulo: "Registro de marcaciones", tipo: { rows: false, dropdown: false }, link: "/directivo/registroentradasalida", rol_usuario: ROL_DIRECTIVO_UNIDAD },
                        { titulo: "Registro de marcaciones", tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/admin", rol_usuario: ROL_DIRECTIVO_UNIDAD },
                        //{ titulo: OPCION_TITULO_HISTORICO_MARCACIONES, tipo: { rows: false, dropdown: false }, link: ROUTE_HISTORIAL_MARCACIONES, rol_usuario: ROL_USUARIO },
                        //{ titulo: OPCION_TITULO_HISTORICO_MARCACIONES, tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/user/informacion-laboral/marcaciones", rol_usuario: ROL_USUARIO },
                    ], tipo: { rows: true, dropdown: false }
                },*/
                {
                    titulo: "Vinculación ", entries: [
                        { titulo: "Firmar Aviso de Entrada", tipo: { rows: false, dropdown: false }, link: "/directivo/firmaAvisoEntrada", rol_usuario: ROL_DIRECTIVO_UNIDAD },
                        { titulo: "Historial Firmas Aviso de Entrada", tipo: { rows: false, dropdown: false }, link: "/directivo/historialFirmasAE", rol_usuario: ROL_DIRECTIVO_UNIDAD },
                    ], tipo: { rows: true, dropdown: false }
                },
                {
                    titulo: "Solicitudes Administrativas",
                    entries: [
                        {
                            titulo: "Horas Extras",
                            entries: [
                                //{ titulo: OPCION_TITULO_ASIGNACION_PRESUPUESTO, tipo: { rows: false, dropdown: false }, link: "/directivo/proyeccionHorasExtras/asignacionpresupuesto", rol_usuario: ROL_DIRECTIVO_UNIDAD },

                                { titulo: OPCION_TITULO_MODIFICACION_PRESUPUESTO, tipo: { rows: false, dropdown: false }, link: "/directivo/proyeccionHorasExtras/modificacionpresupuesto", rol_usuario: ROL_DIRECTIVO_UNIDAD },

                                //{ titulo: OPCION_TITULO_HISTORIAL_MOD_PRESUPUESTO, tipo: { rows: false, dropdown: false }, link: "/directivo/historialmodpresupuesto", rol_usuario: ROL_DIRECTIVO_UNIDAD },

                                //{ titulo: "Proyección Horas Extras", tipo: { rows: false, dropdown: false }, link: "/directivo/proyeccionHorasExtras/inicio", rol_usuario: ROL_DIRECTIVO_UNIDAD },

                                //{ titulo: "Planificación Horas Extras", tipo: { rows: false, dropdown: false }, link: "/directivo/planificacionHorasExtras", rol_usuario: ROL_DIRECTIVO_UNIDAD },
                                //{ titulo: "Planificación Horas Extras", tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/directivo/planificacionhorasextras", rol_usuario: ROL_DIRECTIVO_UNIDAD },

                                //{ titulo: "Historial Planificación Horas Extras", tipo: { rows: false, dropdown: false }, link: "/directivo/historialplanificacionHorasExtras", rol_usuario: ROL_DIRECTIVO_UNIDAD },

                                //{ titulo: "Aprobación Solicitudes Horas Extras", tipo: { rows: false, dropdown: false }, link: "/directivo/aprobacionHorasExtras", rol_usuario: ROL_DIRECTIVO_UNIDAD },
                                //{ titulo: "Aprobación Solicitudes Horas Extras", tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/directivo/aprobaciondirectivos", rol_usuario: ROL_DIRECTIVO_UNIDAD },

                                //{ titulo: "Historial Solicitudes Horas Extras", tipo: { rows: false, dropdown: false }, link: "/directivo/HistorialSolicitudesHE", rol_usuario: ROL_DIRECTIVO_UNIDAD },

                                //{ titulo: OPCION_TITULO_FIRMA_DOC_PAGO_HE, tipo: { rows: false, dropdown: false }, link: "/directivo/firmadocumentopago", rol_usuario: ROL_DIRECTIVO_UNIDAD },


                                //{ titulo: "DashBoard Horas Extras", tipo: { rows: false, dropdown: false }, link: "/directivo/PresupuestoDashBoard", rol_usuario: ROL_DIRECTIVO_UNIDAD },

                                //{ titulo: "Modificación Presupuesto", tipo: { rows: false, dropdown: false }, link: "/directivo/ModificacionPresupuesto", rol_usuario: ROL_DIRECTIVO_UNIDAD },

                            ],
                            tipo: { rows: true, dropdown: false }
                        },
                        //{
                        //    titulo: "Vacaciones, Permisos / Licencias", entries: [
                        //        //{
                        //        //    titulo: "Planificación Vacaciones",
                        //        //    entries: [
                        //        //        { titulo: "Personal Administrativo", tipo: { rows: false, dropdown: false }, link: "/directivo/administrar_planificacion/administrativo", rol_usuario: ROL_DIRECTIVO_UNIDAD },
                        //        //        { titulo: "Personal Docente", tipo: { rows: false, dropdown: false }, link: "/directivo/administrar_planificacion/docente", rol_usuario: ROL_DIRECTIVO_UNIDAD },
                        //        //    ],
                        //        //    tipo: { rows: true, dropdown: false }
                        //        //},
                        //        { titulo: "Aprobación Vacaciones", tituloStyled: STYLED_OPCION_APROBACION_SOLICIUDES, tipo: { rows: false, dropdown: false }, link: "/directivo/aprobacionSolicitudes" },
                        //        { titulo: "Historial Aprobación", tipo: { rows: false, dropdown: false }, link: "/directivo/historialaprobacionSolicitudes" },
                        //    ], tipo: { rows: true, dropdown: false }
                        //},
                        /*{ titulo: "Proyectos institucionales", tipo: { rows: false, dropdown: false }, link: "/directivo/proyectosinstitucionales", rol_usuario: ROL_DIRECTIVO_UNIDAD },*/
                        { titulo: "Designación Proyectos institucionales", tipo: { rows: false, dropdown: false }, link: "/directivo/proyectosinstitucionalesautoridad", rol_usuario: ROL_RECTOR },
                        /*{ titulo: "Consulta Proyectos institucionales", tipo: { rows: false, dropdown: false }, link: "/directivo/proyectosinstitucionalesconsultor", rol_usuario: ROL_RECTOR },*/
                    ],
                    tipo: { rows: true, dropdown: false }
                },
                /*{
                    titulo: "Otros ", entries: [
                        
                    ], tipo: { rows: true, dropdown: false }
                },*/
                {
                    titulo: "Desvinculación",
                    // entries: [
                    //     { titulo: "Certificación de deudas", tipo: { rows: false, dropdown: false }, link: `${URL_DESVINCULACION}/admin/reporte-de-deudas`, rol_usuario: ROL_DIRECTIVO_UNIDAD },
                    //     { titulo: "Aprobación de Solicitudes", tipo: { rows: false, dropdown: false }, link: `${URL_DESVINCULACION}/admin/solicitudes-de-renuncia`, rol_usuario: ROL_DIRECTIVO_UNIDAD },
                    //     { titulo: "Documentos a firmar", tipo: { rows: false, dropdown: false }, link: `${URL_DESVINCULACION}/admin/documentos-a-firmar`, rol_usuario: ROL_DIRECTIVO_UNIDAD },
                    //     { titulo: "Solicitud para Terminación de Contrato por Cumplimiento de Plazo", tipo: { rows: false, dropdown: false }, link: `${URL_DESVINCULACION}/admin/terminacion-contrato`, rol_usuario: ROL_DIRECTIVO_UNIDAD },
                    //     { titulo: "Solicitud para Terminación Unilateral de Contrato", tipo: { rows: false, dropdown: false }, link: `${URL_DESVINCULACION}/admin/terminacion-unilateral`, rol_usuario: ROL_DIRECTIVO_UNIDAD },
                    //     { titulo: "Notificación Desvinculación Unilateral", tipo: { rows: false, dropdown: false }, link: `${URL_DESVINCULACION}/admin/notificardesvinculacionunilateral`, rol_usuario: ROL_DIRECTIVO_UNIDAD },
                    //     { titulo: "Historial de Certificaciones de deudas", tipo: { rows: false, dropdown: false }, link: `${URL_DESVINCULACION}/admin/reportecertificadodeuda`, rol_usuario: ROL_DIRECTIVO_UNIDAD },
                    //     { titulo: "Historial de Desvinculaciones de la Unidad", tipo: { rows: false, dropdown: false }, link: `${URL_DESVINCULACION}/admin/historialsolicitudes`, rol_usuario: ROL_DIRECTIVO_UNIDAD },
                    //     { titulo: "Historial Desvinculaciones autorizadas", tipo: { rows: false, dropdown: false }, link: `${URL_DESVINCULACION}/admin/historialsolicitudesautorizadas`, rol_usuario: ROL_DIRECTIVO_UNIDAD },

                    // ],
                    entries: RUTAS_DESVINCULACION_DIRECTIVO.map((val, ind) => {
                        return (
                            { titulo: val.nombreRuta, tipo: { dropdown: false, rows: false }, link: `${URL_DESVINCULACION}${val.layout}${val.ruta}`, rol_usuario: ROL_DIRECTIVO_UNIDAD }
                        )
                    }),
                    tipo: { rows: true, dropdown: false }
                },

            ],
            tipo: { rows: true, dropdown: false },
            rol_usuario: ROL_DIRECTIVO_UNIDAD
        },
    ]

    let OpcionesDelegado: Array<opcionesSideBar> = [{
        titulo: "DIRECTIVO UNIDAD",
        icon: () => { return <DirectivoUNIDAD id="icono_opcion_directivo" className="iconoBarraPrincipal" /> },
        entries: [
            //{
            //    titulo: "Planificación Vacaciones",
            //    entries: [
            //        { titulo: "Personal Administrativo", tipo: { rows: false, dropdown: false }, link: "/directivo/administrar_planificacion/administrativo", rol_usuario: ROL_DELEGADO },
            //        { titulo: "Personal Docente", tipo: { rows: false, dropdown: false }, link: "/directivo/administrar_planificacion/docente", rol_usuario: ROL_DELEGADO },
            //    ],
            //    tipo: { rows: true, dropdown: false }
            //},
            //{
            //    titulo: "Horas Extras",
            //    entries: [
            //        { titulo: "Proyección Horas Extras", tipo: { rows: false, dropdown: false }, link: "/directivo/proyeccionHorasExtras/inicio", rol_usuario: ROL_DELEGADO },
            //        { titulo: "Planificación Horas Extras", tipo: { rows: false, dropdown: false }, link: "/directivo/planificacionHorasExtras", rol_usuario: ROL_DELEGADO },
            //        { titulo: "Aprobación Solicitudes Horas Extras", tipo: { rows: false, dropdown: false }, link: "/directivo/aprobacionHorasExtras", rol_usuario: ROL_DELEGADO },//************  sujeto a cambios*/
            //    ],
            //    tipo: { rows: true, dropdown: false }
            //},

        ],
        tipo: { rows: true, dropdown: false },
        rol_usuario: ROL_DELEGADO
    }]

    let OpcionesAnalistaGPE: Array<opcionesSideBar> = [{
        titulo: "DIRECTIVO UNIDAD",
        icon: () => { return <DirectivoUNIDAD id="icono_opcion_directivo" className="iconoBarraPrincipal" /> },
        entries: [
            {
                titulo: "Horas Extras",
                entries: [
                    { titulo: OPCION_TITULO_ASIGNACION_PRESUPUESTO, tipo: { rows: false, dropdown: false }, link: "/directivo/proyeccionHorasExtras/asignacionpresupuesto", rol_usuario: ROL_ANALISTA_GPE },
                    { titulo: OPCION_TITULO_MODIFICACION_PRESUPUESTO, tipo: { rows: false, dropdown: false }, link: "/directivo/proyeccionHorasExtras/modificacionpresupuesto", rol_usuario: ROL_ANALISTA_GPE },
                    //{ titulo: OPCION_TITULO_HISTORIAL_MOD_PRESUPUESTO, tipo: { rows: false, dropdown: false }, link: "/directivo/proyeccionHorasExtras/historialmodpresupuesto", rol_usuario: ROL_ANALISTA_GPE },
                ],
                tipo: { rows: true, dropdown: false }
            },

        ],
        tipo: { rows: true, dropdown: false },
        rol_usuario: ROL_ANALISTA_GPE
    }]

    const STYLED_OPCION_SOLICIUD_VACACIONES = (
        <div className="containerTituloOpcionSolicitudVacaciones">
            <div>{"Solicitudes de vacaciones/"}</div>
            <div>{"Permisos imputables a vacaciones/"}</div>
            <div>{"Reintegro/Reprogramación"}</div>
        </div>
    )



    let OpcionesUsuarioGeneral: Array<opcionesSideBar> = [
        {
            titulo: "MI PERFIL",
            icon: () => { return <div><IconoOpcionUsuario id="icono_opcion_usuario" className="iconoBarraPrincipal" /></div> },
            entries: [
                /*{
                    titulo: NOMBRE_OPCION_DATOS_PERSONALES,
                    entries: [
                        { titulo: "Actualización de Datos", tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/user/datos-personales/datos-generales" },
                        { titulo: "Generar Hoja de Vida", tipo: { rows: false, dropdown: false }, link: "/web/generarHojaVida" }
                    ],
                    tipo: { rows: true, dropdown: false }
                },*/
                /*{ titulo: NOMBRE_OPCION_DATOS_PERSONALES, tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/user/datos-personales/datos-generales" },*/
                { titulo: "Nuevo Talento Humano", tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/admin" },
                /*{
                    titulo: "Asistencia", entries: [
                        //{ titulo: "Registro de marcaciones ", tipo: { rows: false, dropdown: false }, link: "/directivo/registroentradasalida", rol_usuario: ROL_ASESOR },
                        //{ titulo: "Registro de receso/almuerzo", tipo: { rows: false, dropdown: false }, link: "/web/registro_recesoalmuerzo", rol_usuario: ROL_USUARIO },
                        { titulo: "Registro de marcaciones ", tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/admin", rol_usuario: ROL_ASESOR },
                        { titulo: "Registro de receso/almuerzo", tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/admin", rol_usuario: ROL_USUARIO },
                        //{ titulo: OPCION_TITULO_HISTORICO_MARCACIONES, tipo: { rows: false, dropdown: false }, link: ROUTE_HISTORIAL_MARCACIONES, rol_usuario: ROL_USUARIO },
                        //{ titulo: OPCION_TITULO_HISTORICO_MARCACIONES, tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/user/informacion-laboral/marcaciones", rol_usuario: ROL_USUARIO },
                        { titulo: OPCION_TITULO_CONSULTA_HOJA_MARCACIONES, tipo: { rows: false, dropdown: false }, link: ROUTE_HOJA_MARCACIONES, rol_usuario: ROL_USUARIO },
                    ], tipo: { rows: true, dropdown: false }
                },*/
                /*{
                    titulo: "Vinculación", entries: [
                        { titulo: "Documentos a Entregar", tipo: { rows: false, dropdown: false }, link: "/web/vinculacion", rol_usuario: ROL_USUARIO }
                    ], tipo: { rows: true, dropdown: false }
                },*/
                {
                     titulo: "Solicitud de Certificados", tipo: { rows: false, dropdown: false }, link: "/web/solicitud_certificado"
                    //titulo: "Solicitudes Administrativas", entries: [
                        //{ titulo: "Solicitud de Certificados", tipo: { rows: false, dropdown: false }, link: "/web/solicitud_certificado" },
                        //{
                        //    titulo: "Permisos / Licencias", entries: [
                        //        { titulo: "Solicitudes de Permisos/Licencias", tipo: { rows: false, dropdown: false }, link: "/web/solicitud_permisos_licencias", rol_usuario: ROL_USUARIO },
                        //        { titulo: "Historial de Permisos/Licencias", tipo: { rows: false, dropdown: false }, link: "/web/historial_permisos_licencias", rol_usuario: ROL_USUARIO },
                        //    ], tipo: { rows: true, dropdown: false }, rol_usuario: ROL_USUARIO
                        //},
                        //{
                        //    titulo: "Notificación de embarazo", tipo: { rows: false, dropdown: false }, link: "/web/notificacion_embarazo", rol_usuario: ROL_USUARIO
                        //},
                        /*{ titulo: "Vacaciones", tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/user/informacion-laboral/vacaciones" },*/
                        /*{
                            titulo: "Vacaciones", entries: [
                                { titulo: "Planificación Vacaciones", tipo: { rows: false, dropdown: false }, link: "/web/planificacion_vacaciones", rol_usuario: ROL_USUARIO },
                                { titulo: "Solicitudes de: Vacaciones/Reintegro/Permisos imputables a vacaciones/Reprogramación", tituloStyled: STYLED_OPCION_SOLICIUD_VACACIONES, tipo: { rows: false, dropdown: false }, link: "/web/solicitud_vacaciones", rol_usuario: ROL_USUARIO },
                            ], tipo: { rows: true, dropdown: false }
                            , rol_usuario: ROL_USUARIO
                        },*/
                         /*{
                             titulo: "Horas Extras", entries: [
                                 { titulo: "Solicitud de Pago de Horas Extras", tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/user/informacion-laboral/pagos", rol_usuario: ROL_USUARIO },
                             ], tipo: { rows: true, dropdown: false }
                             , rol_usuario: ROL_USUARIO
                         },*/
                    //], tipo: { rows: true, dropdown: false }
                },
                /*{
                    titulo: "Movimientos", entries: [
                        {
                            titulo: "Vacaciones", entries: [
                                { titulo: "Planificación Vacaciones", tipo: { rows: false, dropdown: false }, link: "/web/planificacion_vacaciones", rol_usuario: ROL_USUARIO },
                                { titulo: "Solicitudes de: Vacaciones/Reintegro/Permisos imputables a vacaciones/Reprogramación", tituloStyled: STYLED_OPCION_SOLICIUD_VACACIONES, tipo: { rows: false, dropdown: false }, link: "/web/solicitud_vacaciones", rol_usuario: ROL_USUARIO },

                                // {titulo:"Solicitud de Vacaciones",tipo:{rows:false,dropdown:false}},
                                // {titulo:"Solicitud de Reintegro por Suspensión de Vacaciones",tipo:{rows:false,dropdown:false}},
                                // {titulo:"Anulación Solicitud de Vacaciones",tipo:{rows:false,dropdown:false}},
                                // {titulo:"Consulta de Vacaciones",tipo:{rows:false,dropdown:false}},
                            ], tipo: { rows: true, dropdown: false }
                        },
                        {
                            titulo: "Permisos/Licencias", entries: [
                                { titulo: "Solicitudes de: Permisos/Licencias", tipo: { rows: false, dropdown: false }, link: "/web/solicitud_permisos_licencias", rol_usuario: ROL_USUARIO },
                                { titulo: "Historial de: Permisos/Licencias", tipo: { rows: false, dropdown: false }, link: "/web/historial_permisos_licencias", rol_usuario: ROL_USUARIO },
                            ], tipo: { rows: true, dropdown: false }
                        },
                        {
                            titulo: "Notificación de embarazo",
                            tipo: { rows: false, dropdown: false },
                            link: "/web/notificacion_embarazo",
                            rol_usuario: ROL_USUARIO
                        },
                    ], tipo: { rows: true, dropdown: false }
                },*/
                /*{
                    titulo: "Información de Remuneración", entries: [
                        //{ titulo: "Registro / Actualización de Cuenta Bancaria", tipo: { rows: false, dropdown: false }, link: "/web/datos_bancarios", rol_usuario: ROL_USUARIO },
                        { titulo: "Registro / Actualización de Cuenta Bancaria", tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/user/informacion-laboral/pagos", rol_usuario: ROL_USUARIO },
                        { titulo: "Acumulación / Mensualización Décimos", tipo: { rows: false, dropdown: false }, link: "/web/solicitud_acumula_decimos", rol_usuario: ROL_USUARIO },
                        //{ titulo: "Proyección de Gastos Personales", tipo: { rows: false, dropdown: false }, link: "/web/formulario_gastos_personales", rol_usuario: ROL_USUARIO },
                        { titulo: "Proyección de Gastos Personales", tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/user/informacion-laboral/pagos", rol_usuario: ROL_USUARIO },
                        //{ titulo: "Formulario 107", tipo: { rows: false, dropdown: false }, link: "/web/formulario_107", rol_usuario: ROL_USUARIO }
                        { titulo: "Formulario 107", tipo: { rows: false, dropdown: false }, link: "https://th.espol.edu.ec/user/informacion-laboral/pagos", rol_usuario: ROL_USUARIO }
                    ], tipo: { rows: true, dropdown: false }
                },*/
                //{ titulo: "Acuerdo de Medios Electrónicos", tipo: { rows: false, dropdown: false }, link: "/web/acuerdo_medios_electronicos", rol_usuario: ROL_USUARIO },
                {
                    titulo: "Desvinculación", entries: RUTAS_DESVINCULACION_USUARIO.map((val, ind) => {
                        return (
                            { titulo: val.nombreRuta, tipo: { dropdown: false, rows: false }, link: `${URL_DESVINCULACION}${val.layout}${val.ruta}`, rol_usuario: ROL_USUARIO }
                        )
                    }),
                    tipo: { rows: true, dropdown: false }
                }
                // {titulo:"Permisos/Licencias",tipo:{rows:true,dropdown:false}},
                // {titulo:"Remuneraciones",tipo:{rows:true,dropdown:false}},
                // {titulo:"Promoción",tipo:{rows:true,dropdown:false}},
                // {titulo:"Autoridades ESPOL",tipo:{rows:true,dropdown:false}},
                // {titulo:"Contratación profesores grado",tipo:{rows:false,dropdown:false}}
            ],
            tipo: { rows: true, dropdown: false },
            rol_usuario: ROL_USUARIO
        }
    ]
    let OpcionesConsultor: Array<opcionesSideBar> = [
        {
            titulo: "CONSULTOR",
            icon: () => { return <div><IconoOpcionConsultor id="icono_opcion_consultor" className="iconoBarraPrincipal" /></div> },
            entries: [
                { titulo: "Hoja de Vida", tipo: { rows: false, dropdown: false }, link: "/consultor/ConsultorGenerarHojaVida" },
                { titulo: "Reporte Excel Acreditación", tipo: { rows: false, dropdown: false }, link: "/consultor/ConsultorGenerarHojaVidaExcel" },
                { titulo: "Hoja de Vida Unidad Acreditación", tipo: { rows: false, dropdown: false }, link: "/consultor/ConsultorGenerarHojaVidaUnidad" }
            ],
            tipo: { rows: true, dropdown: false },
            rol_usuario: ROL_CONSULTOR
        }
    ]
    let OpcionesDoctor: Array<opcionesSideBar> = [
        {
            titulo: "DOCTOR",
            icon: () => { return <div><IconoOpcionConsultor id="icono_opcion_consultor" className="iconoBarraPrincipal" /></div> },
            entries: [
                { titulo: "Aprobación de Solicitudes de Permisos", tipo: { rows: false, dropdown: false }, link: "/doctor/AprobacionPermisos" },
                { titulo: "Historial de aprobación", tipo: { rows: false, dropdown: false }, link: "/doctor/historialAprobacionSolicitudes" },
            ],
            tipo: { rows: true, dropdown: false },
            rol_usuario: ROL_DOCTOR_PERMISO
        }
    ]

    let OpcionesBar: Array<opcionesSideBar> = [...OpcionesUsuarioGeneral, ...OpcionesDirectivoUnidad, ...OpcionesDelegado, ...OpcionesAdministrador, ...OpcionesResponsableTH_consultor, ...OpcionesAnalistaGPE,/*...OpcionesNominaTH,*/

    {
        titulo: "COMISIÓN ESCALAFON",
        tipo: { rows: true, dropdown: false },
        rol_usuario: ROL_COMI_ESCALAFON
    },
    ...OpcionesConsultor, ...OpcionesDoctor

    ]

    const value = {
        showSideBar,
        setshowSideBar,
        //Principal
        valoresMenuPrincipal,
        setvaloresMenuPrincipal,
        //subMenuPadre
        subMenu,
        setsubMenu,
        valoressubMenu,
        setvaloressubMenu,
        titulo_opcion_padre,
        settitulo_opcion_padre,
        icono_opcion_padre,
        seticono_opcion_padre,
        //subMenuNieto
        subMenuNieto,
        setsubMenuNieto,
        valoressubMenuNieto,
        setvaloressubMenuNieto,
        titulo_opcion_submenuNieto,
        settitulo_opcion_submenuNieto,
        //subMenuCuartoNivel
        subMenuCuartoNivel,
        setsubMenuCuartoNivel,
        valoressubMenuCuartoNivel,
        setvaloressubMenuCuartoNivel,
        titulo_opcion_CuartoNivel,
        settitulo_opcion_CuartoNivel,
        //Datos Personales
        subMenuDatosPersonales,
        setsubMenuDatosPersonales,
        NOMBRE_OPCION_DATOS_PERSONALES,
        routes_datos_personales,
        routes_usuarios_generales: OpcionesUsuarioGeneral[0].entries ?? new Array<opcionesSideBar>()
    }
    useEffect(() => {
        setvaloresMenuPrincipal(OpcionesBar);
    }, [])

    return (
        <SideBarContext.Provider value={value}>
            {children}
        </SideBarContext.Provider>
    )
}

export default SideBarContextProvider;